<template>
  <div class="message-box">
    <div class="message-box__header">
      <div class="message-box__header__title">{{title}}</div>
    </div>
    <div class="message-box__body"
          v-html="message"></div>
    <div :class="'message-box__footer ' + footerClass"
          v-if="isVisibleFooter">
      <button type="button"
              class="button button_violet"
              @click="modalClose">{{buttonText}}</button>
    </div>
    <button type="button"
            class="button button_icon button_close"
            @click="modalClose">
      <span class="icon icon-close"
            title="Закрыть окно"
            alt="Закрыть окно"></span>
    </button>
  </div>
</template>

<script>
/**
 *  Универсальное модальное окна с информацией.
 *  Заменяет собой дефолтный браузерный алерт, и поэтому предназначен только для вывода информации.
 *  Через props передаётся специальный заголовок и сам текст информации.
 */
export default {
  name: 'ModalAlert',
  props: {
    title: { type: String },
    message: { type: String | Object },
    buttonText: { type: String },
    isVisibleFooter: {
      type: Boolean,
      default: false
    },
    footerClass: { type: String, default: '' },
    modalName: { type: String }
  },
  methods: {
    modalClose () {
      if (this.modalName === 'news-devs') {
        this.$vuedals.close()
        this.$store.commit('MODAL_IS_SHOW_SET', false)
      } else {
        this.$vuedals.close()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalAlert.vue